import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Articulo } from '../../model/articulo';
import { Consorcio } from '../../model/consorcio';
import { DocumentoEntrada } from '../../model/documento-entrada';
import { DocumentoDetalleEntrada } from '../../model/documento-detalle-entrada';

import { ArticuloService } from '../../services/articulo.service';
import { DocumentoDetalleEntradaService } from '../../services/documento-detalle-entrada.service';

@Component({
  selector: 'app-documento-entrada-detalle-mantenimiento',
  templateUrl: './documento-entrada-detalle-mantenimiento.component.html',
  styleUrls: ['./documento-entrada-detalle-mantenimiento.component.css']
})
export class DocumentoEntradaDetalleMantenimientoComponent implements OnInit {

  @Input() detalleSeleccionado: DocumentoDetalleEntrada;
  @Input() documentoSeleccionado: DocumentoEntrada;
  @Output() onReturn = new EventEmitter();

  public consorcio: Consorcio = new Consorcio();
  public _estadoBorrar: boolean = false;
  public _estadoEditar: boolean = false;
  public detalle: DocumentoDetalleEntrada = new DocumentoDetalleEntrada();
  public codigoCliente: string;

  public articulos: Articulo[];
  public query: any;

  constructor(
    private _articuloService: ArticuloService,
    private _documentoDetalleEntradaService: DocumentoDetalleEntradaService
  ) { }

  ngOnInit() {
   if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.detalle.codigoDocumento = this.documentoSeleccionado.codigoDocumento;
    this.detalle.codigoConsorcio = this.documentoSeleccionado.codigoConsorcio;
    if (this.detalleSeleccionado.id != null) {
      this.detalle = this.detalleSeleccionado;
      this._estadoEditar = true;
    }
    this.consorcio.codigoConsorcio = this.documentoSeleccionado.codigoConsorcio;
    this._articuloService.getArticulos(this.consorcio)
      .subscribe(
      data => this.articulos = data,
      err => {
        console.clear();
        console.log(err._body);
      });
  }

  onSubmit() {
    if (this.detalle.id === undefined) {
      this.detalle.id = 0;
    }
    // this._documentoDetalleEntradaService.insert(this.detalle).subscribe(
    //   result => { 
    //     if(result.Resultado === "codigoDocumento ya existe en la base de datos"){
    //         alert("El código del Documento ya existe");
    //     }else{
    //       if(result.Resultado === false){
    //         alert("Ha ocurrido un error...");  
    //       }else{
    //         this.onSubmitSuccess(result);
    //       }
    //     }
    //   },
    //   err => {
    //     console.log(err);
    //   });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this._estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this._estadoBorrar = false;
  }

  borrarRegistro() {
    this._documentoDetalleEntradaService.delete(this.detalle).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-entrada-detalle-mantenimiento/documento-entrada-detalle-mantenimiento.component.ts